
import { defineComponent, ref, watch, onMounted, PropType } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { ElMessage } from "element-plus"
import { Loading } from '@element-plus/icons-vue'
import { CardDrawStatistics } from "@/store/modules/CardDrawRecordModule"

export default defineComponent({
  components: {
    Loading
  },
  props: {
    filters: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => ({})
    }
  },
  setup(props) {
    const store = useStore()
    const loading = ref(false)
    const statistics = ref<CardDrawStatistics>({
      total_draws: 0,
      total_revenue: 0,
      total_energy_consumed: 0,
      guaranteed_draws: 0,
      unique_users: 0,
      pool_stats: [],
      rarity_distribution: [],
      daily_draws: []
    })

    const loadStatistics = () => {
      loading.value = true
      store
        .dispatch(Actions.GET_CARD_DRAW_STATISTICS, props.filters)
        .then(() => {
          statistics.value = store.getters.currentCardDrawStatistics
        })
        .catch(() => {
          ElMessage.error('获取统计数据失败')
        })
        .finally(() => {
          loading.value = false
        })
    }

    onMounted(() => {
      loadStatistics()
    })

    watch(() => props.filters, () => {
      loadStatistics()
    }, { deep: true })

    const getRarityTagType = (rarity: string) => {
      const typeMap: Record<string, string> = {
        'R': 'info',
        'SR': '',
        'SSR': 'success',
        'SSSR': 'warning',
        'UR': 'danger',
        'SAR': 'danger'
      }
      return typeMap[rarity] || ''
    }

    return {
      loading,
      statistics,
      getRarityTagType
    }
  }
})
